import { render, staticRenderFns } from "./dzzhuanlan.vue?vue&type=template&id=0de0aa42&scoped=true"
import script from "./dzzhuanlan.vue?vue&type=script&lang=js"
export * from "./dzzhuanlan.vue?vue&type=script&lang=js"
import style0 from "./dzzhuanlan.vue?vue&type=style&index=0&id=0de0aa42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de0aa42",
  null
  
)

export default component.exports